module.exports = __webpack_public_path__ + "static/keep-your-staff-updated-7a4f7fa0e3eeb93b58555ac6de4b23b5.png";